import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  makeStyles, tokens,
  Menu, MenuTrigger, MenuPopover, MenuList, MenuItem, Avatar, Button,
} from '@fluentui/react-components';
import { API_BASE } from '../config.js';

const FLAG_MAP = {
  lt: require('../assets/img/flags/lt.svg').default,
  en: require('../assets/img/flags/gb.svg').default,
  ru: require('../assets/img/flags/ru.svg').default,
  lv: require('../assets/img/flags/lv.svg').default,
  pl: require('../assets/img/flags/pl.svg').default,
};

const STATIC_LANGS = [
  { lang: 'lt', label: 'Lietuvių', flag: FLAG_MAP.lt },
  { lang: 'en', label: 'English', flag: FLAG_MAP.en },
];

// Fluent `Menu` (ne rankomis rašytas dropdown) su vėliavėlių ikonomis — tas pats
// standartinis meniu mechanizmas kaip prieš tai, tik trigeris vėl rodo vėliavą
// (vartotojo pageidavimu), mažesnę nei buvo originaliai (16px vietoj 20px).
const useStyles = makeStyles({
  trigger: {
    minWidth: 'unset',
    padding: tokens.spacingHorizontalXS,
  },
});

function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const [langs, setLangs] = useState(STATIC_LANGS);
  const s = useStyles();

  useEffect(() => {
    fetch(`${API_BASE}/translations/languages`)
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        if (data && data.length > 0) {
          const active = data.filter(l => l.active !== false);
          if (active.length > 0) {
            setLangs(active.map(l => ({
              lang: l.lang,
              label: l.label,
              flag: FLAG_MAP[l.lang] || null,
            })));
          }
        }
      })
      .catch(() => {});
  }, []);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    localStorage.setItem('language', lng);
  };

  const currentLang = langs.find(l => l.lang === i18n.language) || langs[0];

  if (langs.length <= 1) return null;

  return (
    // positioning="below-end" — meniu dešinysis kraštas lygiuojamas su trigerio
    // dešiniuoju kraštu (plečiasi Į KAIRĘ), ne numatytasis "below-start", kuris
    // pleistus dropdown'ą į DEŠINĘ nuo trigerio ir ant siauresnių ekranų (trigeris
    // yra kraštutinis dešinėje header'e) nuleistų dalį meniu už viewport ribų.
    <Menu positioning="below-end">
      <MenuTrigger disableButtonEnhancement>
        <Button appearance="subtle" className={s.trigger} title={currentLang?.label}>
          {currentLang?.flag && (
            <Avatar image={{ src: currentLang.flag, alt: currentLang.label }} name={currentLang.label} size={16} />
          )}
        </Button>
      </MenuTrigger>
      <MenuPopover>
        <MenuList>
          {langs.map(l => (
            <MenuItem
              key={l.lang}
              icon={l.flag ? <Avatar image={{ src: l.flag, alt: l.label }} name={l.label} size={16} /> : undefined}
              onClick={() => changeLanguage(l.lang)}
            >
              {l.label}
            </MenuItem>
          ))}
        </MenuList>
      </MenuPopover>
    </Menu>
  );
}

export default LanguageSwitcher;
